import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e7893b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "document bg-white relative overflow-y-scroll" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = { class: "title-section-spacing sticky top-0 bg-white z-20" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-left text-primary-600 font-bold" }, "Indietro", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-row pt-6 pb-6" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-bold block text-left pb-4" }, "Gestione documenti")
], -1))
const _hoisted_6 = { class: "buttons items-center flex" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-bold text-left subtitle" }, "Tutti i documenti caricati", -1))
const _hoisted_8 = { class: "buttons-section flex" }
const _hoisted_9 = { class: "searchbar flex" }
const _hoisted_10 = { class: "users-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftArrow = _resolveComponent("LeftArrow")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_DocumentCard = _resolveComponent("DocumentCard")!
  const _component_AddEditDocumentModalDialog = _resolveComponent("AddEditDocumentModalDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "header w-full fixed relative inline-flex cursor-pointer",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }, [
          _createVNode(_component_LeftArrow, { class: "back-arrow" }),
          _hoisted_4
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_PrimaryButton, {
              class: "bg-primary-600 text-white button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowingAddNewDocument = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Aggiungi documenti")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            class: "text px-4 py-3 flex-grow",
            type: "text",
            placeholder: "Cerca documento",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchQuery) = $event)),
            onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.search()), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.searchQuery]
          ]),
          _createVNode(_component_PrimaryButton, {
            class: "button bg-white text-primary flex-none",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.search()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cerca")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (doc) => {
            return (_openBlock(), _createBlock(_component_DocumentCard, {
              key: doc.id,
              "model-value": doc,
              scope: _ctx.DocumentScope.userDocument,
              "user-id": _ctx.userId,
              tags: {},
              "is-document-to-be-approved": _ctx.isDocumentsToBeApproved
            }, null, 8, ["model-value", "scope", "user-id", "is-document-to-be-approved"]))
          }), 128))
        ])
      ])
    ]),
    (_ctx.isShowingAddNewDocument)
      ? (_openBlock(), _createBlock(_component_AddEditDocumentModalDialog, {
          key: 0,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowingAddNewDocument = false)),
          tags: {},
          scope: _ctx.DocumentScope.userDocument,
          "user-id": _ctx.userId,
          "tags-allowed": false
        }, null, 8, ["scope", "user-id"]))
      : _createCommentVNode("", true)
  ]))
}